/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import Loading from '../Shared/Loading'
import MySweetAlert from '../Shared/MySweetAlert'
import { customerAddressesService } from '../../_services/customerAddresses.service'
import ErrorPopUp from '../Shared/ErrorPopUp'
import AddressTypeSelect from '../Shared/AddressTypeSelect'
import { FiEdit, FiTrash2 } from 'react-icons/fi'
import addressTypes from '../../_constants/addressTypes'
import _ from 'lodash'

import { Formik, getIn, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'

import { AiOutlineLoading, AiOutlineSave } from "react-icons/ai";

class Step2 extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      loading: false,
      data: [],
      customerId: '',
      address: {
        customerId: this.props.customerId,
        address: '',
        addressType: '',
      },
      model: {},
      confirmDeleteShow: false,
    }

    this.inputFocus = this.utilizeFocus()

  }

  utilizeFocus = () => {
    const ref = React.createRef()
    const setFocus = () => { ref.current && ref.current.focus() }

    return { setFocus, ref }
  }

  componentDidMount() {
    if (this.props.customerId !== undefined) {
      this.setState({ customerId: this.props.customerId }, () => {
        this.getData()
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.customerId != undefined && nextProps.customerId !== this.state.customerId) {
      this.setState({ customerId: nextProps.customerId }, () => {
        this.getData()
      })
    }
  }

  getData() {
    this.setState({ loading: true })
    customerAddressesService.getAll(this.state.customerId)
      .then((res) => {
        console.log(res.data)
        var data = res.data;
        this.setState({ data: data, loading: false, isSubmitting: false }, () => {
          this.inputFocus.value = ''
          this.inputFocus.setFocus()
        })
      })
      .catch((error) => {
        console.log(error)
        this.handleError(error)
      });
  }

  handleSubmitAddress = (values, setSubmitting, resetForm) => {

    this.setState({ loading: true });

    let dto = values
    dto["customerId"] = values.customerId
    console.log(dto);
    console.log(JSON.stringify(dto));

    if (values.id) {
      customerAddressesService.edit(values.id, JSON.stringify(dto))
        .then((res) => {

          toastr.success('ویرایش آدرس انجام شد');
          setSubmitting(false);

          let address = {};
          address["addressType"] = null
          address["address"] = ''
          address["customerId"] = values.customerId

          this.setState({ address: address }, () => {
            resetForm()
          })

          this.getData()

          // this.props.onClose()

        })
        .catch((error) => {
          console.log(error)
          setSubmitting(false)
        })
    } else {
      customerAddressesService.add(JSON.stringify(dto))
        .then((res) => {

          toastr.success('ثبت آدرس انجام شد');
          setSubmitting(false);

          let address = {};
          address["addressType"] = null
          address["address"] = ''
          address["customerId"] = values.customerId

          this.setState({ address: address }, () => {
            resetForm()
          })

          this.getData()

          // this.props.onClose()

        })
        .catch((error) => {
          console.log(error)
          setSubmitting(false)
        })
    }
  }

  handleError(error) {
    this.setState({ loading: false });
    // toastr.warning('مشکلی پیش آمد', error);
  }


  handleModalEdit = (e) => {
    let _model = e;
    console.log(_model);

    this.setState({ modal: true, address: _model });
  }

  handleDelete = (e) => {
    let _model = e;

    this.setState({ confirmDeleteShow: true, model: _model });
  }

  handleConfirmDelete = () => {
    this.setState({ loading: true, confirmDeleteShow: false });

    customerAddressesService.delete(this.state.model.id)
      .then((res) => {
        toastr.success('حذف آدرس', 'آدرس با موفقیت حذف شد');
        this.getData();
      })
      .catch((error) => {
        this.handleError(error)
      });
  }

  handleSweetAlertHide = () => {
    this.setState({ confirmDeleteShow: false });
  }

  handleCancelEdit = () => {
    let address = this.state.data;
    address["addressType"] = ''
    address["address"] = ''
    address["customerId"] = this.props.customerId

    this.setState({ address: address })
  }

  render() {
    const { data, address, loading } = this.state;
    const { handleSubmitAddress } = this;

    const ValidationSchema = Yup.object().shape({
      // customerId: Yup.string().trim().nullable().required(' '),
      address: Yup.string().trim().nullable().required('آدرس'),
      addressType: Yup.string().trim().nullable().required('نوع آدرس'),
    })

    return (
      <Formik
        enableReinitialize
        initialValues={address}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          setSubmitting(true);
          handleSubmitAddress(values, setSubmitting, resetForm);
        }}
        validationSchema={ValidationSchema}
      >
        {props => {
          const {
            values,
            touched,
            errors,
            setFieldValue,
            setFieldTouched,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            validateForm,
            setSubmitting,
            resetForm,
          } = props;
          return (
            <div style={{ position: 'relative' }}>

              <form onSubmit={handleSubmit}>

                <fieldset className="fieldset">
                  <legend>
                    {values.id ? 'ویرایش آدرس' : 'ثبت آدرس جدید'}
                  </legend>

                  <div className="row display-flex">
                    <div className="col-lg-10 col-lg-offset-1 col-md-10 col-md-offset-1 col-sm-12 col-xs-12">

                      <div className="row">
                        <div className="form-inline">

                          <div className="col-lg-4 col-sm-12">
                            <label>نوع آدرس</label>
                            <AddressTypeSelect name="addressType"
                              value={values.addressType}
                              onChange={(val) => {
                                setFieldValue('addressType', val);
                              }}

                            />
                            <ErrorPopUp error={errors.addressType} touched={touched.addressType} type="select" />
                          </div>

                          <div className="col-md-8 col-sm-12">
                            <label className="pull-right">آدرس</label>
                            <input type="text"
                              ref={this.inputFocus.ref}
                              autoFocus
                              name="address"
                              value={values.address}
                              onChange={e =>
                                setFieldValue("address", e.target.value)}
                              className={
                                getIn(errors, "address") &&
                                  getIn(touched, "address")
                                  ? "text-input has-error rtl"
                                  : "text-input required rtl"
                              }
                            />
                            <ErrorMessage component={ErrorPopUp} name="address" />
                          </div>

                          <div className="col-md-2 col-sm-12">
                            <button
                              type="submit"
                              className={"btn btn-success btn-block has-icon-right" + (isSubmitting ? "isSubmitting" : "")} disabled={isSubmitting}
                              disabled={isSubmitting}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                props.submitForm().then(() => {
                                  validateForm().then(errors => {

                                    console.log(errors)

                                    // if (JSON.stringify(errors) === '{}') {
                                    // if (props.isValid) {
                                    //   handleSubmitAddress(values, setSubmitting, resetForm)
                                    // }

                                  })
                                })
                              }}
                            >
                              {isSubmitting ?
                                <AiOutlineLoading className="mdi-spin" size="18px" />
                                :
                                <AiOutlineSave size="18px" />
                              }ذخیره</button>
                          </div>

                          {values.id && (
                            <div className="col-md-2 col-sm-12">
                              <a className="btn btn-warning" onClick={() => this.handleCancelEdit()}>لغو ویرایش</a>
                            </div>
                          )}


                        </div>
                      </div>

                    </div>
                  </div>

                </fieldset>

              </form>

              <fieldset className="fieldset" style={{ paddingRight: 0, paddingLeft: 0, paddingBottom: 0, overflow: 'hidden', position: 'relative' }}>
                <legend style={{ marginRight: 15 }}>لیست آدرس ها</legend>

                <div style={{ position: 'relative', minHeight: 100 }}>
                  {loading && (<Loading className="small" style={{ borderRadius: 15 }} />)}
                  {data &&
                    <table className="table" style={{ marginBottom: 0 }}>
                      <thead>
                        <tr>
                          <th className="text-center" style={{ width: 60 }}>#</th>
                          <th className="text-center" style={{ width: 200 }}>نوع آدرس</th>
                          <th className="text-center">آدرس</th>
                          <th className="text-center" style={{ width: 180 }}>عملیات</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data && data.map((item, index) => (
                          <TableRow
                            key={"tr-" + item.id}
                            data={item}
                            index={index}
                            onReload={() => this.getData()}
                            handleModalEdit={e => this.handleModalEdit(e)}
                            handleDelete={e => this.handleDelete(e)}
                            setCorrectAnswer={e => this.setCorrectAnswer(e)}
                          />
                        ))}
                      </tbody>
                    </table>
                  }
                </div>

              </fieldset>

              <MySweetAlert
                show={this.state.confirmDeleteShow}
                onCancel={this.handleSweetAlertHide}
                onConfirm={this.handleConfirmDelete}
                title={"آیا از حذف آدرس [" + (addressTypes.filter(el => el.value === this.state.model.addressType)[0] && addressTypes.filter(el => el.value === this.state.model.addressType)[0].label) + "] مطمئن هستید؟"}
              >
              </MySweetAlert>

            </div>
          )
        }}
      </Formik>
    );
  }
}

export default Step2;

const TableRow = ({ data, index, setCorrectAnswer, handleModalEdit, handleDelete }) => {

  return (
    <tr className={data.isCorrect ? 'active' : ''}>
      <td className="text-center">
        {index + 1}
      </td>
      <td className="text-center">{data.addressType !== undefined && addressTypes.filter(el => el.value === data.addressType)[0].label}</td>
      <td className="text-center">{data.address}</td>
      <td className="text-center">

        <a onClick={() => handleModalEdit(data)} className="btn btn-sm btn-simple btn-success bmd-ripple bmd-flat-btn">
          <FiEdit size="24px" />
        </a>

        <a onClick={() => handleDelete(data)} className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn">
          <FiTrash2 size="24px" />
        </a>

      </td>
    </tr>
  )
}